<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="500px" v-if="programa">
      <v-form ref="formCodigo" v-model="valid" lazy-validation @submit.prevent="saveData">
        <v-card tile>
          <v-toolbar dark color="orange" dense flat class="max-height">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text"> Insertar codigo al Programa</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-card-title primary-title>
              <p class="text-center primary--text">
                {{ this.programa.nombre_compuesto }}
              </p>
            </v-card-title>
            <v-card-subtitle primary-title class="mb-0 pb-0">
              <p>Debe Introducir el codigo de contabilidad, esto actualizara el programa con este codigo para reportes futuros</p>
              <v-text-field :rules="[(v) => !!v || 'Codigo Obligatorio']" dense outlined v-model="codigo_contabilidad" label="Codigo de Contabilidad">
              </v-text-field>
              <p class="mb-0 pb-0 red--text font-weight-bold">NOTA: Esta ventana solo aparece una sola vez por programa</p>
            </v-card-subtitle>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="success" small v-if="codigo_contabilidad" rounded>
              <v-icon class="mr-1"> mdi-content-save</v-icon> Guardar Codigo
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded small @click="cancel"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
export default {
  data() {
    return {
      dialog: false,
      valid: false,
      api_rest: process.env.VUE_APP_API_REST,
      programa_id: null,
      programa: null,
      codigo_contabilidad: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(programa_id, programa) {
      this.programa = programa;
      this.programa_id = programa_id;
      this.dialog = true;
    },

    saveData() {
      if (this.$refs.formCodigo.validate()) {
        const url = `${this.api_rest}/api/esam/programa/codigo/insertar`;
        xaxios
          .post(url, { programa_id: this.programa_id, codigo: this.codigo_contabilidad.trim().toUpperCase() })
          .then(() => {
            this.$emit('clickedAddCode', { value: true, code: this.codigo_contabilidad.trim().toUpperCase() });
            this.closeDialog();
          })
          .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
      }
    },
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.programa_id = null;
        this.codigo_contabilidad = null;
        this.programa = null;
      });
    },
  },
};
</script>
